const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-mantine-resources/shared/mantineProvider");